import * as getters from '@/store/modules/cards/history/getters'
import * as mutations from '@/store/modules/cards/history/mutations'
import * as actions from '@/store/modules/cards/history/actions'

const state = {
    historyList: [],
    historyListHasMore: false,
    statusList: [],
    channelsList: [],
    operationDetails: []
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
